import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

export const getAuthHeaders = () => {
  if (!Auth.hasAuthCookie()) return {};

  const {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  } = Auth.getAuthData();
  return {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  };
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  Object.assign(wootApi.defaults.headers.common, getAuthHeaders());
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
